var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLightBulbIdea = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.428 49.1446C30.5119 48.4922 30.5183 47.3889 30.5008 46.3907C30.4765 44.9992 29.8138 43.7091 28.8161 42.7389C27.7851 41.7364 26.4976 40.359 25.7082 39.0541C24.0743 36.3537 23.2951 31.3301 28.7938 31.8121C32.4274 32.1306 34.3317 35.1139 34.334 37.261C34.3353 38.5371 32.8692 39.0232 31.8139 38.3058C31.184 37.8776 30.6104 37.2779 30.428 36.5378C29.7019 33.5919 32.0614 28.7434 37.3861 30.3391C41.8032 31.6628 41.1377 35.0034 40.7746 36.5378C40.4116 38.0721 35.7296 42.7424 35.7296 42.7424",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5398 59.0997L38.5984 56.0571",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3176 56.0572L39.5286 52.051",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2839 52.4566L34.3616 49.4646",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7784 14.5796C22.7208 14.5796 14.6937 21.3227 14.6937 29.6407C14.6937 33.978 16.9259 38.278 20.121 41.0262C22.8461 43.0786 25.4396 46.3596 25.6147 49.3127H38.323C38.323 47.1204 40.1821 43.5462 43.2052 41.0262C46.4002 38.278 48.6329 33.978 48.6329 29.6407C48.6329 21.3227 42.8128 14.5796 31.7784 14.5796Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1965 57.5276C39.6578 55.17 39.8419 52.7877 39.8419 49.3127H23.7675C23.9628 52.7589 24.352 54.8971 25.3457 56.8618C26.3394 58.8265 28.3886 60.3674 32.0127 60.3674C34.8768 60.3674 36.7352 59.8853 38.1965 57.5276Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.821 61.1038C33.3251 61.7214 32.739 61.8973 32.0211 61.8973C31.315 61.8973 30.7337 61.5577 30.2604 60.9785",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.362 60.6443C33.7155 61.2619 32.9514 61.4378 32.0155 61.4378C31.0951 61.4378 30.3373 61.0982 29.7202 60.519",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 45.7068,
    y1: 13.6503,
    x2: 50.136,
    y2: 9.17016,
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 54.1908,
    y1: 23.6344,
    x2: 58.8768,
    y2: 22.3241,
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 53.5239,
    y1: 37.4284,
    x2: 58.8007,
    y2: 39.4493,
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 46.5383,
    y1: 47.5409,
    x2: 50.278,
    y2: 51.0192,
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: -1,
    x2: 7.29997,
    y2: -1,
    transform: "matrix(-0.703061 -0.71113 -0.71113 0.703061 18.2842 14.6526)",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: -1,
    x2: 5.86563,
    y2: -1,
    transform: "matrix(-0.963061 -0.269284 -0.269284 0.963061 10.5029 24.8667)",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: -1,
    x2: 6.65048,
    y2: -1,
    transform: "matrix(-0.933857 0.357647 0.357647 0.933857 11.7676 38.0046)",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: -1,
    x2: 6.10731,
    y2: -1,
    transform: "matrix(-0.73223 0.681057 0.681057 0.73223 18.875 47.592)",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 32.5999,
    y1: 8.39771,
    x2: 32.5999,
    y2: 3.10289,
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLightBulbIdea);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "lightBulbIdea.9c445ae61d4c9473431787e113729b48.svg";